import { WriteRoute } from '@/service';

/**
 * @class @name FactFind
 * @description Exposes menu store module
 */
export default class FactFindStore {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name fetchFactFindList
			 * @param {function} commit
			 * @param {Object} payload
			 */
			fetchFactFindList(context, payload) {
				return WriteRoute.list(payload);
			},

			/**
			 * @async @name fetchFile
			 * @param {function} commit
			 * @param {Object} payload
			 */
			fetchFile(context, { executionId, resource, filename }) {
				return WriteRoute.downloadFile(executionId, resource, filename);
			},

			/**
			 * @async @name ex
			 * @param {function} commit
			 * @param {Object} payload
			 */
			exportFactFind(context, { id, compliance = false }) {
				return WriteRoute.exportFactFind(id, { compliance });
			}
		};
	}
}
